module.exports = __webpack_public_path__ + "static/media/Surat-Info.58c23154.png";